/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ReminderOverrides } from './ReminderOverrides';
import {
    ReminderOverridesFromJSON,
    ReminderOverridesFromJSONTyped,
    ReminderOverridesToJSON,
    ReminderOverridesToJSONTyped,
} from './ReminderOverrides';
import type { RequestItemInput } from './RequestItemInput';
import {
    RequestItemInputFromJSON,
    RequestItemInputFromJSONTyped,
    RequestItemInputToJSON,
    RequestItemInputToJSONTyped,
} from './RequestItemInput';

/**
 * 
 * @export
 * @interface CreateRequestRequest
 */
export interface CreateRequestRequest {
    /**
     * 
     */
    client_request_id: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    message?: string | null;
    /**
     * 
     */
    due_at?: Date | null;
    /**
     * 
     */
    items: Array<RequestItemInput>;
    /**
     * 
     */
    recipient_participant_ids: Set<string>;
    /**
     * 
     */
    reminder_overrides?: ReminderOverrides;
}

/**
 * Check if a given object implements the CreateRequestRequest interface.
 */
export function instanceOfCreateRequestRequest(value: object): value is CreateRequestRequest {
    if (!('client_request_id' in value) || value['client_request_id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('recipient_participant_ids' in value) || value['recipient_participant_ids'] === undefined) return false;
    return true;
}

export function CreateRequestRequestFromJSON(json: any): CreateRequestRequest {
    return CreateRequestRequestFromJSONTyped(json, false);
}

export function CreateRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'client_request_id': json['client_request_id'],
        'title': json['title'],
        'message': json['message'] === undefined ? undefined : json['message'] === null ? null : json['message'],
        'due_at': json['due_at'] === undefined ? undefined : json['due_at'] === null ? null : (parseDateTime(json['due_at'])),
        'items': ((json['items'] as Array<any>).map(RequestItemInputFromJSON)),
        'recipient_participant_ids': new Set(json['recipient_participant_ids']),
        'reminder_overrides': json['reminder_overrides'] == null ? undefined : ReminderOverridesFromJSON(json['reminder_overrides']),
    };
}

export function CreateRequestRequestToJSON(json: any): CreateRequestRequest {
    return CreateRequestRequestToJSONTyped(json, false);
}

export function CreateRequestRequestToJSONTyped(value?: CreateRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_request_id': value['client_request_id'],
        'title': value['title'],
        'message': value['message'],
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'items': ((value['items'] as Array<any>).map(RequestItemInputToJSON)),
        'recipient_participant_ids': Array.from(value['recipient_participant_ids'] as Set<any>),
        'reminder_overrides': ReminderOverridesToJSON(value['reminder_overrides']),
    };
}

